import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '../components/ui/Button';
import { Anchor } from 'lucide-react';
import { motion } from 'framer-motion';
export function WelcomePage() {
  const navigate = useNavigate();
  return <div className="relative min-h-screen flex flex-col items-center justify-center overflow-hidden bg-surface" data-id="element-259">
      {/* Background Image with Overlay */}
      <div className="absolute inset-0 z-0" style={{
      backgroundImage: 'url(https://images.unsplash.com/photo-1478131143081-80f7f84ca84d?auto=format&fit=crop&q=80&w=2000)',
      backgroundSize: 'cover',
      backgroundPosition: 'center'
    }} data-id="element-260">
        <div className="absolute inset-0 bg-gradient-to-b from-black/30 via-black/20 to-black/80" data-id="element-261" />
      </div>

      {/* Content */}
      <div className="relative z-10 w-full max-w-md px-6 flex flex-col items-center text-center" data-id="element-262">
        <motion.div initial={{
        scale: 0.8,
        opacity: 0
      }} animate={{
        scale: 1,
        opacity: 1
      }} transition={{
        duration: 0.5
      }} className="mb-8 bg-white/10 backdrop-blur-md p-4 rounded-2xl border border-white/20" data-id="element-263">
          <Anchor className="w-12 h-12 text-white" data-id="element-264" />
        </motion.div>

        <motion.h1 initial={{
        y: 20,
        opacity: 0
      }} animate={{
        y: 0,
        opacity: 1
      }} transition={{
        delay: 0.2,
        duration: 0.5
      }} className="text-4xl md:text-5xl font-bold text-white mb-4 tracking-tight" data-id="element-265">
          Discover Your <br data-id="element-266" />
          <span className="text-teal-400" data-id="element-267">Next Catch</span>
        </motion.h1>

        <motion.p initial={{
        y: 20,
        opacity: 0
      }} animate={{
        y: 0,
        opacity: 1
      }} transition={{
        delay: 0.4,
        duration: 0.5
      }} className="text-lg text-gray-200 mb-10 leading-relaxed" data-id="element-268">
          Find the best fishing spots, check regulations, and get expert
          recommendations in one place.
        </motion.p>

        <motion.div initial={{
        y: 20,
        opacity: 0
      }} animate={{
        y: 0,
        opacity: 1
      }} transition={{
        delay: 0.6,
        duration: 0.5
      }} className="w-full" data-id="element-269">
          <Button size="lg" className="w-full bg-teal-500 hover:bg-teal-600 text-white border-none shadow-xl shadow-teal-900/20" onClick={() => navigate('/')} data-id="element-270">
            Get Started
          </Button>
        </motion.div>
      </div>
    </div>;
}